import { Link } from "react-router-dom";
import { SkeletonCard } from "@/components/base/Skeleton";
import { useApi } from "@/hooks/useApi";
import type { GameItem } from "@/lib/types";
import GamesGrid from "@/pages/games/components/GamesGrid";
import { visibleGames } from "@/pages/games/utils";

// 메인 홈 «심심풀이 게임» 섹션. 위치는 «줄다리기» 바로 아래.
// 게임 로직은 서버가 서비스하므로 카드만 깔고 링크를 건다.
// 데이터를 못 받으면(오류·0건) 흔적 없이 사라진다.
export default function GamesSection() {
  const { data, loading, error } = useApi<GameItem[]>("games.php");
  const games = visibleGames(data ?? []);

  if (!loading && (error || games.length === 0)) return null;

  return (
    <section className="w-full bg-background-50 px-4 py-14 md:px-6 md:py-16">
      <div className="mx-auto max-w-6xl">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <h2 className="flex items-center gap-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              <span aria-hidden="true">🎮</span>
              심심풀이 게임
            </h2>
            <p className="mt-2 text-foreground-600">
              짬날 때 한 판. 명예의 전당에 이름을 올려보세요
            </p>
          </div>
          <Link
            to="/games"
            className="inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-primary-200 bg-primary-50 px-5 py-2.5 text-sm font-semibold text-primary-700 transition-colors hover:bg-primary-100"
          >
            명예의 전당
            <i className="ri-arrow-right-line" aria-hidden="true"></i>
          </Link>
        </div>

        {loading ? (
          <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:gap-4 lg:grid-cols-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <SkeletonCard key={i} />
            ))}
          </div>
        ) : (
          <GamesGrid games={games} />
        )}
      </div>
    </section>
  );
}